import { render, staticRenderFns } from "./PublicacionesListado.vue?vue&type=template&id=24f99612&"
import script from "./PublicacionesListado.vue?vue&type=script&lang=js&"
export * from "./PublicacionesListado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports